import React from "react";

const Eyebrow = ({ children, className = "", index }) => (
  <span className={`t-eyebrow inline-flex items-center gap-3 ${className}`}>
    <span className="inline-block h-px w-8 bg-electric" aria-hidden="true" />
    {typeof index === "number" && (
      <span className="text-electric">{String(index).padStart(2, "0")}</span>
    )}
    {children}
  </span>
);

export default Eyebrow;
